import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { viewWasteTypeAction } from '../../actions';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

function WasteTypeView({ wasteType }) {
    return (
        <div className="col-lg-12">
            <div className="card">
                {
                    wasteType ?
                        <>
                            <div className="header d-flex justify-content-between align-items-center">
                                <h2>
                                    {wasteType.title}
                                </h2>
                            </div>
                            <div className="body table-responsive">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th>Title:</th>
                                            <td>{wasteType.title}</td>

                                        </tr>
                                        <tr>
                                            <th>Created At:</th>
                                            <td>{moment(wasteType.createdAt).format('YYYY-MM-DD hh:mm a')}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </> :
                        <div className="text-center">
                            <Loader
                                type="Bars"
                                color="#00BFFF"
                                height={100}
                                width={100}
                                timeout={3000} //3 secs
                            />
                        </div>

                }

            </div>
        </div>
    )
}

export default connect(null, { viewWasteTypeAction })(WasteTypeView)